export const AXIOS_HOST = process.env.REACT_APP_BCE_HOST || "http://localhost:3001"